import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  Paper,
  Table,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
  IconButton,
  withStyles,
  Checkbox,
  Button,
  FormControlLabel,
} from '@material-ui/core'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'

import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import WmDispatchEmployeeItem from './WmDispatchEmployeeItem'

// utils
import { hasAccess } from '../../utils/api'
import SearchField from '../common/SearchField'

const WmDispatchVehiclesItemEditable = EditableHOCWrapper(WmDispatchEmployeeItem)
const styles = (theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 500,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
})

class WmDispatchShopInfoVehicles extends Component {
  constructor(props) {
    super(props)
    this.state = {
      term: '',
      checked: false,
      page: 0,
      rowsPerPage: 10,
      rowsPerPageOptions: [10, 25, 50, 100],
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
  }

  onChangeTerm = (e) => {
    this.setState({ term: e.target.value })
  }

  onSearch = (e) => {
    console.log(e)
  }

  handleChange = (e) => {
    this.setState({ checked: e.target.checked })
  }

  render() {
    const { page, rowsPerPage, rowsPerPageOptions } = this.state
    const { employeeList = [], shopsList = [], shopId, shopInfo } = this.props
    return (
      <div>
        <Typography variant="title">{(shopInfo && shopInfo.name) || ''}</Typography>
        <Grid container className="margin-top-medium remove-margin">
          <Grid item xs={12} sm={4}>
            <div className="category-rightside">
              <SearchField
                onSearch={this.onSearch}
                onChange={this.onChangeTerm}
                value={this.state.term}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              className="field-check"
              control={<Checkbox checked={this.state.checked} onChange={this.handleChange} />}
              label="Show Linked Vehicles"
            />
          </Grid>
          <Grid item xs={12} sm={2} style={{ paddingRight: 3 }}>
            <Button variant="outlined" color="primary" className="b-outline" fullWidth>
              <span className="button-text">Add Vehicle</span>
            </Button>
          </Grid>
        </Grid>
        <Grid container className="full-width">
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Paper className="margin-top-small" elevation={1}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Vehicle Name</TableCell>
                    <TableCell>Model</TableCell>
                    <TableCell>Plate #</TableCell>
                    <TableCell>WM Dispatch ID</TableCell>
                    {hasAccess() ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {employeeList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(
                      (employee) =>
                        employee.shops &&
                        employee.shops.find(
                          (shopId) =>
                            shopsList &&
                            shopsList.find(
                              (shop) =>
                                shop.id === shopId && shop.appTarget && shop.appTarget === 'Retail',
                            ),
                        ) && (
                          <WmDispatchVehiclesItemEditable key={employee.id} dataToEdit={employee} />
                        ),
                    )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      colSpan={3}
                      count={employeeList.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActionsWrapped}
                      rowsPerPageOptions={rowsPerPageOptions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(WmDispatchShopInfoVehicles)

/* ------ PAGINATION ------ */
const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
})

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0)
  }

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1)
  }

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1)
  }

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
    )
  }

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    )
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
}

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
  TablePaginationActions,
)



// WEBPACK FOOTER //
// ./src/components/WmDispatch/WmDispatchShopInfoVehicles.js